import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const AddFooter = () => {
  const navigate = useNavigate();
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  const [formData, setFormData] = useState({
    image: null,
    preview: "",
    link: "",
  });

  // Handle file upload and preview
  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        image: file,
        preview: URL.createObjectURL(file),
      }));
    }
  };

  // Handle text input
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.image || !formData.link.trim()) {
      alert("Please upload an image and enter the app link!");
      return;
    }

    try {
      const data = new FormData();
      data.append("link", formData.link);
      data.append("image", formData.image);

      const res = await axios.post(`${baseUrl}/footers/app/add`, data, {
  headers: { "Content-Type": "multipart/form-data" },
});


      if (res.status === 200) {
        alert("✅ Footer app added successfully!");
        navigate("/settings/footer");
      } else {
        alert("⚠️ Something went wrong while adding the footer app!");
      }
    } catch (err) {
      console.error("Add footer app failed:", err);
      alert("❌ Error while adding footer app!");
    }
  };

  return (
    <div className="main-container container-fluid p-5">
      {/* Page Header */}
      <div className="page-header mb-4">
        <h1 className="page-title text-xl font-semibold mb-2">Add Footer App</h1>
        <ol className="breadcrumb text-sm">
          <li className="breadcrumb-item">
            <a href="/settings/footer" className="text-primary">Home</a>
          </li>
          <li className="breadcrumb-item active text-gray-600">Footer Apps</li>
        </ol>
      </div>

      {/* Add Form */}
      <form
        onSubmit={handleSubmit}
        className="card p-4 shadow-sm border rounded-xl"
        encType="multipart/form-data"
      >
        {/* Image Upload */}
        <div className="mb-5">
          <label className="form-label font-medium">Upload Image</label>
          <div
            className="border-2 border-dashed rounded-xl w-[150px] h-[150px] flex flex-col items-center justify-center cursor-pointer transition-all hover:border-blue-500 hover:bg-blue-50"
            onClick={() => document.getElementById("footer-image").click()}
          >
            <input
              type="file"
              id="footer-image"
              accept="image/*"
              className="hidden"
              onChange={handleFileChange}
              required
            />
            {formData.preview ? (
              <img
                src={formData.preview}
                alt="Preview"
                className="w-full h-full object-cover rounded-xl"
              />
            ) : (
              <p className="text-gray-500 text-center text-sm">
                Drag & drop an image here or click
              </p>
            )}
          </div>
          <p className="text-sm text-gray-500 mt-2">Recommended Size: 150px × 150px</p>
        </div>

        {/* App Link */}
        <div className="mb-4">
          <label className="form-label font-medium">App Link</label>
          <input
            type="text"
            name="link"
            value={formData.link}
            onChange={handleChange}
            className="form-control border rounded-md p-2 w-full"
            placeholder="Enter app link..."
            required
          />
        </div>

        {/* Submit */}
        <button
          type="submit"
          className="btn btn-primary bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default AddFooter;
